import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-data-table-filter',
  templateUrl: './data-table-filter.component.html',
  styleUrls: ['./data-table-filter.component.less']
})
export class DataTableFilterComponent {
  @Input() title: string;
  @Input() applyEnabled = false;
  @Input() resetEnabled = false;

  @Output() apply = new EventEmitter<void>();
  @Output() reset = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  constructor() {
  }

  onReset(): void {
    this.reset.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onApply(): void {
    this.apply.emit();
  }

}
